import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

export const DocumentScoringResultSummary = ({ t, scoringResult }) => (
  <Grid container spacing={1}>
    <Grid item xs={12} md={4}>
      <strong>{t('DocumentEdit.Scoring.ScoringResult.ScoringResult')} :</strong> <span>{scoringResult.scoringResult}</span>
    </Grid>
    <Grid item xs={12} sm={4}>
      <strong>{t('DocumentEdit.Scoring.ScoringResult.AssetScoreClass')} :</strong> <span>{scoringResult.assetScoreClass}</span>
    </Grid>
    <Grid item xs={12} sm={4}>
      <strong> {t('DocumentEdit.Scoring.ScoringResult.ClientScoreClass')} :</strong> <span>{scoringResult.clientScoreClass}</span>
    </Grid>
  </Grid>
);
DocumentScoringResultSummary.propTypes = {
  t: PropTypes.func.isRequired,
  scoringResult: PropTypes.object.isRequired
};

export default withTranslation()(DocumentScoringResultSummary);
